import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

function Footer() {
    const [showCookiesConsent, setShowCookiesConsent] = useState(true); // For Cookies
    const [isGoTopActive, setIsGoTopActive] = useState(false); // State for "Go to Top" button visibility

    const acceptCookies = () => {
        localStorage.setItem("cookiesAccepted", "true");
        setShowCookiesConsent(false);
    };

    // Check if cookies are already accepted on mount
    useEffect(() => {
        const cookiesAccepted = localStorage.getItem("cookiesAccepted");
        if (cookiesAccepted === "true") {
            setShowCookiesConsent(false);
        }
    }, []);

    // Handle scroll event for "Go to Top" button
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 600) {
                setIsGoTopActive(true);
            } else {
                setIsGoTopActive(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // Scroll to top function
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };


    return (
        <>
            {/* Start Footer Area */}
                <div className="footer-area two">
                    <div className="container-fluid eighteen-padding bg-color-theme-footer pt-100 radius-30">
                        <div className="container p-0">
                            <div className="newsletter two pb-100" data-aos="zoom-in-up" data-aos-delay={200}>
                                <div className="row align-items-center">
                                    <div className="col-lg-7 col-md-6">
                                        <div className="section-heading mb-0">
                                            <span className="sub-title">Let your journey begin with us</span>
                                            <h2>Ready to get started?</h2>
                                        </div>
                                    </div>
                                    <div className="col-lg-5 col-md-6">
                                        <div className="newsletter-btn">
                                            <NavLink to="/download-ifepay-app" className="default-btn me-4">Send Money <i className="ri-arrow-right-up-line" /></NavLink>
                                            {/* <NavLink to="https://ifepay.co.uk/app/app-login" className="default-btn me-4" target='_blank'>Send Money <i className="ri-arrow-right-up-line" /></NavLink> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row" data-aos="zoom-in-up" data-aos-delay={200}>
                                <div className="col-xl-4 col-md-6">
                                    <div className="footer-weight part-one">
                                        <NavLink to="/home" className="footer-logo d-block">
                                            <img src="assets/images/logo.svg" alt="image" />
                                        </NavLink>
                                        <p>
                                        We are KP Agency limited trading as Ifepay registered with the financial conduct Authority (FCA) in the UK with registration number 511981.
                                        Registered with companies House with registration number 06833430
                                        </p>
                                        <ul className="social">
                                            <li><span>Follow Us:</span></li>
                                            <li>
                                                <NavLink to="https://www.facebook.com/share/14ZpMEY63G/?mibextid=wwXIfr" target="_blank">
                                                    <i className="ri-facebook-fill" />
                                                </NavLink>
                                            </li>
                                            {/* <li>
                                                <NavLink to="https://www.twitter.com/" target="_blank">
                                                    <i className="ri-twitter-x-line" />
                                                </NavLink>
                                            </li> */}
                                            <li>
                                                <NavLink to="https://www.instagram.com/ifepaytransfer?igsh=NG5wdHFsMXh0N2Rr&utm_source=qr" target="_blank">
                                                    <i className="ri-instagram-line" />
                                                </NavLink>
                                            </li>
                                            {/* <li>
                                                <NavLink to="https://www.linkedin.com/" target="_blank">
                                                    <i className="ri-linkedin-fill" />
                                                </NavLink>
                                            </li> */}
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-md-6">
                                    <div className="footer-weight part-two ps-5">
                                        <h3>Quick Links</h3>
                                        <ul className="service-link">
                                            <li>
                                                <NavLink to="/money-transfer">Money Transfer</NavLink>
                                            </li>
                                            <li>
                                                <NavLink to="/general-faq">FAQ's</NavLink>
                                            </li>
                                            <li>
                                                <NavLink to="/contact-us">Contact Us</NavLink>
                                            </li>
                                            <li>
                                                <NavLink to="/help">Help</NavLink>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-md-6">
                                    <div className="footer-weight part-three ps-5">
                                        <h3>Legals Links</h3>
                                        <ul className="service-link">
                                            <li>
                                                <NavLink to="/terms-and-conditions">Terms and Conditions</NavLink>
                                            </li>
                                            <li>
                                                <NavLink to="/privacy-policy">Privacy Policy</NavLink>
                                            </li>
                                            <li>
                                                <NavLink to="/complaints-policy">Complaint Policy</NavLink>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-md-6">
                                    <div className="footer-weight ps-5">
                                        <h3>Get In Touch</h3>
                                        <ul className="get-touch">
                                            <li>
                                                <img src="assets/images/svg/map.svg" alt="image" />
                                                <span><b>Address:</b></span>
                                                <NavLink to="https://maps.app.goo.gl/B1eYbFnsuJXh78xj9" target="_blank">
                                                   Suite 5, Community house, 19 - 21 Eastern Road ,Post code RM13NH, Romford
                                                </NavLink>
                                            </li>
                                            <li>
                                                <img className="phone" src="assets/images/svg/mail.svg" alt="image" />
                                                <span><b>Email:</b></span>
                                                <NavLink to="mailto:info@ifepay.co.uk">
                                                   info@ifepay.co.uk
                                                </NavLink>
                                            </li>
                                            <li>
                                                <img className="phone" src="assets/images/svg/phone.svg" alt="image" />
                                                <span><b>Phone:</b></span>
                                                <NavLink to="tel:02030061093">02030061093</NavLink> / <NavLink to="tel:07707337351">07707337351</NavLink>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Footer Area */}
                {/* Start Copyright Area */}
                <div className="copyright-area two">
                    <div className="container">
                        <div className="copyright-border border-0">
                            <div className="row g-4 align-items-center text-center">
                                <div className="col-lg-12 col-md-12">
                                    <p>©{new Date().getFullYear()} <NavLink to="/" target="_blank"><span>Ifepay</span></NavLink> All Rights Reserved. Powerd By <NavLink to="https://www.calyx-solutions.com/" target="_blank">Calyx Solutions</NavLink></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Copyright Area */}
                {/* Go top Btn */}
                <div className={`go-top ${isGoTopActive ? 'active' : ''}`} onClick={scrollToTop}>
                    <i className="ri-arrow-up-fill" />
                </div>
                {/* Go top Btn End */}

            {showCookiesConsent && (
                <div className="wrapper-cookie">
                    <div className="d-flex gap-2" style={{ alignItems: 'flex-start' }}>
                        <img src="assets/images/cookies.png" alt="cookies consent" />
                        <h5 className='text-white'>Cookies Consent</h5>
                    </div>
                    <div className="content mt-3">
                        <p className='text-white mb-3'>
                            We use cookies to improve your browsing experience and for marketing purposes.
                        </p>
                        <div>
                            <button className="btn bg-primary text-dark" onClick={acceptCookies}>
                                <span className='txt'>I understand</span>
                            </button>
                            <NavLink to="/privacy-policy" className="item ms-3" style={{ textDecoration: 'underline' }} onClick={scrollToTop}>
                                Privacy Policy
                            </NavLink>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Footer;
